var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSheildIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0013 36.6663C16.1402 35.6941 12.9527 33.4788 10.4388 30.0205C7.92491 26.5622 6.66797 22.7219 6.66797 18.4997V8.33301L20.0013 3.33301L33.3346 8.33301V18.4997C33.3346 22.7219 32.0777 26.5622 29.5638 30.0205C27.0499 33.4788 23.8624 35.6941 20.0013 36.6663ZM20.0013 33.1663C22.8902 32.2497 25.2791 30.4163 27.168 27.6663C29.0569 24.9163 30.0013 21.8608 30.0013 18.4997V10.6247L20.0013 6.87467L10.0013 10.6247V18.4997C10.0013 21.8608 10.9457 24.9163 12.8346 27.6663C14.7235 30.4163 17.1124 32.2497 20.0013 33.1663Z",
    fill: "#2D2F31"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSheildIcon);
export default __webpack_public_path__ + "static/media/sheildIcon.eee80eb2deb10513a06533f891ed69b7.svg";
export { ForwardRef as ReactComponent };